import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons';
import { Button, Flex, Separator, Slider, Text } from '@radix-ui/themes';
import { BiStation } from 'react-icons/bi';
import { useDash } from '@/app/context/dash-context';
import {
  goLive,
  navigateFrame,
  selectIsControlsDisabled,
  setOpacity,
} from '@/entities/collection';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';

export function NavHeader() {
  const frames = useAppSelector((state) => state.collection.framesList);
  const currentFrameIndex = useAppSelector(
    (state) => state.collection.selectedFrameIndex
  );
  const totalCount = frames.length;
  const isOffline = currentFrameIndex === null || currentFrameIndex > -1;
  const dispatch = useAppDispatch();
  const opacity = useAppSelector((state) => state.collection.opacity);
  const { player } = useDash();
  const isControlsDisabled = useAppSelector(selectIsControlsDisabled);

  const handleCatchUpToLive = () => {
    if (player) {
      player.seekToOriginalLive();
      // Also resume playback if it was paused
      if (player.isPaused()) {
        player.play();
      }
    }
  };

  return (
    <header className="h-12 shadow-md flex items-center">
      <div className="flex items-center gap-2 px-2 flex-grow">
        <Flex gap="4" justify="between" mx="2">
          <Button
            className="w-8 h-8 p-0"
            variant="ghost"
            color="gray"
            size="1"
            disabled={isControlsDisabled}
            onClick={() => {
              dispatch(navigateFrame({ direction: 'left' }));
            }}
          >
            <ChevronLeftIcon />
          </Button>
          <Button
            className="w-8 h-8 p-0"
            variant="ghost"
            color="gray"
            size="1"
            disabled={isControlsDisabled}
            onClick={() => {
              dispatch(navigateFrame({ direction: 'right' }));
            }}
          >
            <ChevronRightIcon />
          </Button>
        </Flex>
        <Slider
          size="3"
          className="flex-grow"
          value={[
            isOffline
              ? ((currentFrameIndex + 1) / totalCount) * 100
              : (totalCount / totalCount) * 100,
          ]}
        />
        <Text className="whitespace-nowrap">
          {isOffline ? currentFrameIndex + 1 : totalCount} / {totalCount}
        </Text>
        <Button
          color={isOffline ? 'gray' : 'red'}
          variant={isOffline ? 'outline' : 'solid'}
          onClick={() => {
            if (isOffline) {
              dispatch(goLive());
            } else {
              handleCatchUpToLive();
            }
          }}
        >
          <BiStation />
          LIVE
        </Button>
      </div>
      <Separator orientation="vertical" size="4" />
      <div className="flex items-center gap-2 px-2">
        <Text>BG Opacity</Text>
        <Slider
          step={0.1}
          value={[opacity * 100]}
          className="w-20"
          onValueChange={([value]) => dispatch(setOpacity(value / 100))}
        />
      </div>
    </header>
  );
}
